<template>
    <el-main class="container" ref="sea-container" v-loading="loading">
        <div class="" style="border: none !important">
            <!-- 表头搜索 -->
            <div class="handle-box">
                <div class="handle-left">
                    <el-button type="primary" icon="el-icon-plus" class="handle-del mr10" @click="fetchMember" v-if="showFetchButton">获取</el-button>
                    <el-input type="number" v-model="query.keyword" placeholder="手机号" @keyup.native.enter="getTableData()" clearable class="handle-input mr10"></el-input>
                    <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                    <el-button type="primary" icon="el-icon-plus" class="handle-del mr10" @click="apply">申请</el-button>
                    <!-- <el-tag type="danger" class="mt4">支持手机号“全号”及 “后4或5位尾号”查询</el-tag> -->
                </div>
            </div>
            <!-- 回访详情 -->
            <el-drawer size="50%" :with-header="false" :visible.sync="customerDrawer" custom-class="member-detail" :wrapperClosable="false" :close-on-press-escape="false">
                <div class="drawerContent">
                    <div class="drawerHead">
                        <div class="drawerHeadTop">
                            <div class="headLeft">
                                <el-avatar shape="square"></el-avatar>
                                <div class="nameMsg">
                                    <p class="name">{{ customer.realname }}</p>
                                </div>
                            </div>
                            <div class="headRight">
                                <i class="pointer el-icon-close left" @click="closeShowCustomerDrawer"></i>
                            </div>
                        </div>
                        <div class="drawerHeadBot">
                            <div>
                                <p class="bot-first">电话</p>
                                <p class="bot-second mobile">{{ customer.mobile }}</p>
                            </div>
                            <div>
                                <p class="bot-first">重要程度</p>
                                <p class="bot-second">{{ customer.level }}</p>
                            </div>
                            <div>
                                <p class="bot-first">客户状态</p>
                                <p class="bot-second">{{ customer.status }}</p>
                            </div>
                            <div>
                                <p class="bot-first">跟进人</p>
                                <p class="bot-second">{{ customer.user }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <el-tabs v-model="activeName">
                    <el-tab-pane label="客户资料" name="first" class="customer-tab-pane">
                        <el-card class="box-card">
                            <div slot="header" class="clearfix card-header">
                                <span class="basicMsg">基本信息</span>
                            </div>
                            <el-row :gutter="20">
                                <el-col :span="4">
                                    <div class="grid-content bg-purple cardTit">姓名</div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="grid-content bg-purple">{{ customer.realname }}</div>
                                </el-col>
                                <el-col :span="4">
                                    <div class="grid-content bg-purple cardTit">电话</div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="grid-content bg-purple">{{ customer.mobile }}</div>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="4">
                                    <div class="grid-content bg-purple cardTit">婚期</div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="grid-content bg-purple">{{ customer.wedding_date }}</div>
                                </el-col>
                                <el-col :span="4">
                                    <div class="grid-content bg-purple cardTit">联系方式</div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="grid-content bg-purple">{{ customer.mobile1 }}</div>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="4">
                                    <div class="grid-content bg-purple cardTit">桌数</div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="grid-content bg-purple">{{ customer.banquet_size }} - {{ customer.banquet_size_end }}</div>
                                </el-col>
                                <el-col :span="4">
                                    <div class="grid-content bg-purple cardTit">预算</div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="grid-content bg-purple">{{ customer.budget }} - {{ customer.budget_end }}</div>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="4">
                                    <div class="grid-content bg-purple cardTit">区域</div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="grid-content bg-purple">{{ customer.zone }}</div>
                                </el-col>
                                <el-col :span="4">
                                    <div class="grid-content bg-purple cardTit">咨询酒店</div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="grid-content bg-purple">{{ customer.hotel }}</div>
                                </el-col>
                            </el-row>
                        </el-card>
                        <el-card class="box-card">
                            <div slot="header" class="clearfix card-header">
                                <span class="basicMsg">系统信息</span>
                            </div>
                            <el-row :gutter="20">
                                <el-col :span="4">
                                    <div class="grid-content bg-purple cardTit">最近联系时间</div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="grid-content bg-purple">{{ customer.last_visit_time }}</div>
                                </el-col>
                                <el-col :span="4">
                                    <div class="grid-content bg-purple cardTit">获取客户时间</div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="grid-content bg-purple">{{ customer.allocate_time }}</div>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="4">
                                    <div class="grid-content bg-purple cardTit">创建时间</div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="grid-content bg-purple">{{ customer.create_time }}</div>
                                </el-col>
                                <el-col :span="4">
                                    <div class="grid-content bg-purple cardTit">创建人</div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="grid-content bg-purple">{{ customer.operator }}</div>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="4">
                                    <div class="grid-content bg-purple cardTit">来源</div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="grid-content bg-purple">{{ customer.source }}</div>
                                </el-col>
                                <el-col :span="4">
                                    <div class="grid-content bg-purple cardTit">客户编号</div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="grid-content bg-purple">{{ customer.member_no }}</div>
                                </el-col>
                            </el-row>
                        </el-card>
                    </el-tab-pane>
                    <el-tab-pane label="回访记录" name="second" class="customer-tab-pane">
                        <el-card class="box-card">
                            <div slot="header" class="clearfix card-header">
                                <span class="basicMsg">跟进记录</span>
                            </div>
                            <div class="chart-data-dimension">
                                <el-table class="chart-data-table" :data="visitGroup" style="width: 100%">
                                    <el-table-column prop="visitor" label="回访者" align="center"></el-table-column>
                                    <el-table-column prop="visit_times" label="回访次数" align="center"></el-table-column>
                                    <el-table-column prop="create_time" label="获取时间" align="center"></el-table-column>
                                    <el-table-column prop="status" label="回访状态" align="center"></el-table-column>
                                    <el-table-column prop="next_visit_time" label="下次回访时间" align="center"></el-table-column>
                                    <el-table-column prop="last_visit_time" label="最近跟进时间" align="center"></el-table-column>
                                </el-table>
                            </div>
                        </el-card>

                        <el-card class="box-card">
                            <div slot="header" class="clearfix card-header">
                                <span class="basicMsg">回访历史</span>
                            </div>
                            <div class="chart-data-dimension">
                                <el-table class="chart-data-table" :data="visitList" style="width: 100%">
                                    <el-table-column prop="visitor" label="回访者" width="120" align="center"></el-table-column>
                                    <el-table-column prop="create_time" label="回访时间" align="center"></el-table-column>
                                    <el-table-column prop="status" label="回访状态" width="120" align="center"></el-table-column>
                                    <el-table-column prop="content" label="跟进记录"></el-table-column>
                                </el-table>
                            </div>
                        </el-card>
                    </el-tab-pane>

                    <el-tab-pane label="进店记录" name="third" class="customer-tab-pane">
                        <div class="record-shop">
                            <el-table class="chart-data-table" :data="intoList">
                                <el-table-column prop="status" label="进店状态"></el-table-column>
                                <el-table-column prop="subscribe_time" label="预约进店时间"></el-table-column>
                                <el-table-column prop="real_time" label="实际进店时间"></el-table-column>
                                <el-table-column prop="next_time" label="下次进店时间"></el-table-column>
                                <el-table-column prop="remark" label="备注"></el-table-column>
                            </el-table>
                        </div>
                    </el-tab-pane>

                    <el-tab-pane label="回访录音" name="sixth" class="customer-tab-pane">
                        <div class="visit-record">
                            <el-table class="chart-data-table" :data="callRecord">
                                <el-table-column prop="fwdStartTime" label="日期" width="150" align="center"></el-table-column>
                                <el-table-column prop="operator" label="操作者" align="center"></el-table-column>
                                <el-table-column prop="status" label="接通状态" align="center"></el-table-column>
                                <el-table-column prop="fwdStartTime" label="接通时间" align="center"></el-table-column>
                                <el-table-column prop="billsec" label="持续时间" align="center"></el-table-column>
                                <el-table-column prop="recordFileDownloadUrl" label="录音" align="center">
                                    <template slot-scope="scope">
                                        <el-link type="success" target="_blank" :href="scope.row.recordFileDownloadUrl">查看</el-link>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </el-drawer>

            <el-table :data="tableData" ref="multipleTable" header-cell-class-name="table-header" @selection-change="handleSelectionChange" v-loading="loading" :height="tableHeight" :max-height="tableHeight">
                <template v-for="(row, key) in tableFields">
                    <template v-if="row.id == 'selection'">
                        <el-table-column :key="key" :id="row.id" type="selection" width="55" align="center">
                            <!-- <template slot-scope="scope">
                            <div>{{scope.row.}}</div>
                            </template>-->
                        </el-table-column>
                    </template>
                    <template v-else-if="row.id == 'operations'">
                        <el-table-column :key="key" :label="row.label" :width="row.width" :align="row.align">
                            <template slot-scope="scope">
                                <template v-for="btn in row.buttons">
                                    <el-button :key="btn.label" @click="actions(scope.row, btn.action)" :type="btn.type" :size="btn.size">{{
                                        btn.label
                                    }}</el-button>
                                </template>
                            </template>
                        </el-table-column>
                    </template>
                    <template v-else-if="row.visible != 'hidden'">
                        <el-table-column :key="key" :id="row.id" :prop="row.id" :label="row.label" :width="row.width" :align="row.align" :show-overflow-tooltip="row.tooltip">
                            <template slot-scope="scope">
                                <el-link v-if="row.action" type="primary" :underline="false" @click="actions(scope.row, row.action)">{{
                                    scope['row'][row['id']]
                                }}</el-link>
                                <el-link v-else type="info" :underline="false">{{ scope['row'][row['id']] }}</el-link>
                            </template>
                        </el-table-column>
                    </template>
                </template>
            </el-table>

            <div class="footer-box">
                <div class="download"></div>
                <div class="pagination">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page" :page-sizes="[10, 15, 30, 50, 100]" :page-size="limit" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
                </div>
            </div>
        </div>
    </el-main>
</template>

<script>
export default {
    name: 'basetable',
    data() {
        let tableHeight = window.innerHeight - 239;
        return {
            loading: false,

            customerDrawer: false,
            activeName: 'first',
            newsTypeList: [],
            sourceList: [],
            cityList: [],
            areaList: [],
            hotelList: [],
            statusList: [],
            staffList: [],
            increaseData: [],
            callRecord: [],
            visitList: [],
            visitGroup: [],
            customer: {},
            intoList: [],
            applyIds: [],
            showFetchButton: false,

            // 搜索条件
            query: {
                user_id: '',
                active_status: '',
                visit_amount: '',
                keyword: '',
                daterange: [],
                department_id: '',
                hotel_id: '',
                source_id: '',
                news_type: '',
                city_id: ''
            },
            // 列表数据
            tableFields: [],
            tableData: [],
            tableHeight: tableHeight,
            pagination: {
                page: 1,
                limit: 15,
                total: 0
            },
            page: 1,
            limit: 15,
            total: 0,

            // 日期选项
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                },
                {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                },
                {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }
                ]
            }
        };
    },
    created() {
        this.getTableData();

        // 获取picker数据
        this.getPickerList();
    },
    mounted() {
        this.$nextTick(() => {
            this.tableHeight = window.innerHeight - 240;
        })
    },
    methods: {
        // 获取列表数据
        getTableData() {
            let that = this;
            let url = '/api/customer.member/sea';
            let query = that.query;
            query['pagination'] = this.pagination;
            that.loading = true;
            this.$post(url, query).then(function (response) {
                let result = response.data;
                that.tableFields = result.tableFields;
                that.tableData = result.tableData;
                that.pagination = result.pagination;
                that.page = result.pagination.page;
                that.limit = result.pagination.limit;
                that.total = result.pagination.total;
                if (query.keyword.length == 11 && result.tableData.length > 0) {
                    that.showFetchButton = true;
                } else {
                    that.showFetchButton = false;
                }
                that.loading = false;
            });
        },
        // 搜索
        handleSearch() {
            this.getTableData();
        },
        handleSizeChange(val) {
            this.pagination.limit = val;
            this.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.pagination.page = val;
            this.page = val;
            this.getTableData();
        },
        // 获取下拉列表
        getPickerList() {
            let url = '/api/customer.picker/items';
            let that = this;
            this.$post(url, {}).then(function (response) {
                let result = response.data;
                that.newsTypeList = result.newsTypeList;
                that.sourceList = result.sourceList;
                that.cityList = result.cityList;
                that.hotelList = result.storeList;
                that.statusList = result.statusList;
                that.staffList = result.staffList;
            });
        },
        // 主表选中事件
        handleSelectionChange(e) {
            let ids = [];
            e.forEach((row, key) => {
                ids.push(row.id);
            });
            this.applyIds = ids;
        },
        // 申请客资
        apply() {
            let that = this;
            let ids = this.applyIds;
            if (ids.length == 0) {
                this.$message({
                    message: '请选择要申请的客资',
                    type: 'warning'
                });
                return false;
            }

            this.$confirm('确认申请客资?', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '申请',
                cancelButtonText: '取消'
            })
                .then(() => {
                    let url = '/api/customer.member/apply';
                    this.$post(url, {
                        ids: ids
                    }).then(function (response) {
                        that.$message({
                            type: 'info',
                            message: response.msg
                        });
                    });
                })
                .catch((action) => { });
        },
        // 全号搜索获取客资
        fetchMember() {
            let that = this;
            let ids = this.applyIds;
            if (ids.length == 0) {
                this.$message({
                    message: '请选择要获取的客资',
                    type: 'warning'
                });
                return false;
            }

            this.$confirm('确认获取该客资?', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            })
                .then(() => {
                    let url = '/api/customer.member/fetchMember';
                    this.$post(url, {
                        ids: ids
                    }).then(function (response) {
                        that.$message({
                            type: 'info',
                            message: response.msg
                        });
                    });
                })
                .catch((action) => { });
        },
        // 显示客资详情
        showCustomerDrawer() {
            let that = this;
            that.customerDrawer = true;
            // 获取客资信息
            let url = '/api/customer.member/show';
            let query = {
                member_id: that.currentRow.id
            };
            that.$post(url, query).then(function (response) {
                let result = response.data;
                that.customer = result.customer;
                that.visitList = result.visitList;
                that.visitGroup = result.visitGroup;
                that.callRecord = result.callRecord;
                that.intoList = result.intoList;
            });
        },
        // 关闭回访drawer
        closeShowCustomerDrawer() {
            this.customerDrawer = false;
        },
        actions(row, type) {
            let that = this;
            that.currentRow = row;
            switch (type) {
                // 显示
                case 'show':
                    that.showCustomerDrawer();
                    break;
            }
        }
    }
};
</script>

<style lang="less">
@import url('@/assets/css/member.less');

.customer-tab-pane {
    height: calc(100vh - 208px);
    overflow: auto;
}

.mt4 {
    margin-top: 4px;
}
</style>
